<div class="content">
   <div class="panel panel-body" *ngIf="metaInfo; else none">
      <div style="margin-bottom: 10px; word-wrap: break-word; white-space: pre-wrap;" [innerHTML]="metaInfo"></div>
   </div>
   <ng-template #none>
      <span style="color: #e9e9e9;">
         Sin Información adicional.
      </span>
   </ng-template>
</div>